import { createContext } from "react";

export type CardContextTypes = {
  mediaPosition?: "top" | "middle" | "bottom";
  contentPosition?: "top" | "middle" | "bottom";
  actionPosition?: "top" | "middle" | "bottom";
  headerPosition?: "top" | "middle" | "bottom";
};

export const CardContext = createContext<CardContextTypes>({
  mediaPosition: "top",
  contentPosition: "middle",
  actionPosition: "bottom",
  headerPosition: "top",
});
